import { AccountMembership, AccountMembershipRole } from '@mkp/account-membership/models';
import { createActionGroup, props } from '@ngrx/store';

export const editPermissionsActions = createActionGroup({
  source: 'Edit permissions',
  events: {
    'Roles Saved': props<{
      roles: { role: AccountMembershipRole }[];
      _version: string;
      accountMembershipId: string;
      isSelfUpdate: boolean;
    }>(),
    'Delete Account Membership': props<{
      accountMembership: AccountMembership;
      isSelfDelete: boolean;
    }>(),
  },
});
